import { Box } from "@mui/material";

// Makes the whole zone card clickable while the card keeps its normal look
// (title + coloured button(s) at the bottom).
//
// Invisible click zones sit behind the card content:
// - one action  -> the whole card runs it
// - two actions -> the left half runs the first (e.g. Stop), the right half the
//                  second (e.g. Resume), matching the two buttons side by side
// The buttons themselves still work as before; clicking next to them (on the
// title, icon or empty space) runs the same action. Disabled actions do nothing.
// The page runs on tablets: a pressed zone darkens slightly (touch feedback); the
// hover tint only applies to devices with a real hover (mouse).
//
// actions:  [{ key, onClick, disabled }]
// children: the card content (icon, title, buttons)

const ControlCardActionArea = ({ actions = [], children }) => (
  <Box
    sx={{
      position: "relative",
      height: "100%",
      display: "flex",
      flexDirection: "column",
    }}
  >
    {actions.length > 0 && (
      <Box
        aria-hidden="true"
        sx={{ position: "absolute", inset: 0, display: "flex", zIndex: 0 }}
      >
        {actions.map((action, index) => {
          const enabled = !action.disabled && !!action.onClick;
          return (
            <Box
              key={action.key || index}
              data-testid={`card-zone-${action.key || index}`}
              onClick={enabled ? action.onClick : undefined}
              sx={{
                flex: 1,
                cursor: enabled ? "pointer" : "default",
                transition: "background-color 0.15s ease",
                WebkitTapHighlightColor: "transparent",
                ...(enabled
                  ? {
                      "@media (hover: hover)": {
                        "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
                      },
                      "&:active": { backgroundColor: "rgba(0, 0, 0, 0.1)" },
                    }
                  : {}),
              }}
            />
          );
        })}
      </Box>
    )}

    {/* Content is drawn over the zones. Only real controls catch clicks; a click
        anywhere else falls through to the zone underneath. */}
    <Box
      sx={{
        position: "relative",
        zIndex: 1,
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        pointerEvents: "none",
        "& .MuiButtonBase-root:not(.Mui-disabled)": { pointerEvents: "auto" },
      }}
    >
      {children}
    </Box>
  </Box>
);

export default ControlCardActionArea;
